import { Language } from '@generated/base-types';
import { CurrentUserFragment } from '@new/common/services/current-user.generated';
import { ManagerError } from '@new/common/utils/error-parser';

export class SetCurrentLanguage {
  public static readonly type = '[Context] Set Current Language';
  constructor(public readonly language: Language) {}
}

export class LoadCurrentUser {
  public static readonly type = '[Context] Load Current User';
}

export class LoadCurrentUserSuccess {
  public static readonly type = '[Context] Load Current User Success';
  constructor(public readonly currentUser: CurrentUserFragment) {}
}

export class LoadCurrentUserFailure {
  public static readonly type = '[Context] Load Current User Failure';
  constructor(public readonly error: ManagerError) {}
}
